import {
    Box,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';

import { PortalCategoryType } from '@lifeserver/shared';

const CategoryTypeOptions: Array<{
    value: PortalCategoryType;
    title: string;
    description: string;
}> = [
    {
        value: 'manual',
        description:
            'You choose the posts for the category in the publication feed.',
        title: 'Manual Category',
    },
    {
        value: 'automatic',
        description:
            'Posts are populated in the category by the system, from the post pool.',
        title: 'Automatic Category',
    },
    {
        value: 'gift',
        description:
            'Posts are populated automatically based on the currently available gifts.',
        title: 'Gift Category',
    },
    {
        value: 'eventsCalendar',
        description:
            'A calendar view of scheduled events. Each event is a separate post with its own date range.',
        title: 'Events Calendar',
    },
];

export interface CategoryTypeInputProps {
    value: PortalCategoryType;
    onChange?: (value: PortalCategoryType) => void;
}

export const CategoryTypeInput = ({
    value,
    onChange,
}: CategoryTypeInputProps) => {
    return (
        <FormControl>
            <RadioGroup
                value={value}
                onChange={(_, value) => onChange?.(value as PortalCategoryType)}
                row
            >
                {CategoryTypeOptions.map((option) => (
                    <Box key={option.value}>
                        <FormControlLabel
                            value={option.value}
                            control={<Radio />}
                            label={
                                <Box>
                                    <Typography sx={{ fontWeight: 'bold' }}>
                                        {option.title}
                                    </Typography>
                                    <Typography variant="body2">
                                        {option.description}
                                    </Typography>
                                </Box>
                            }
                        />
                    </Box>
                ))}
            </RadioGroup>
        </FormControl>
    );
};
